import { render, staticRenderFns } from "./i_search.vue?vue&type=template&id=0a51653f&"
import script from "./i_search.vue?vue&type=script&lang=js&"
export * from "./i_search.vue?vue&type=script&lang=js&"
import style0 from "./i_search.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports